export class WatcherFormController {
    constructor($state, $q, $stateParams, $scope, User, WatchersDao, BinMgrDao, WebhooksDao, xrayLicensesDao,
                XRayUIModelSaver, TOOLTIPS, JFrogModal, JFrogUIUtils, JFrogGridFactory, XRayUIPermissions,
                IgnoreModal, ComponentsDao, $filter, EventXDao, XRayUtils, $timeout, PolicyDao, commonGridColumns,
                IgnoreDao, JFrogTableViewOptions) {
        this.$scope = $scope;
        this.$state = $state;
        this.PolicyDao = PolicyDao;
        this.ignoreDao = IgnoreDao;
        this.eventXDao = EventXDao;
        this.commonGridColumns = commonGridColumns;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.xrayUtils = XRayUtils;
        this.IgnoreModal = IgnoreModal;
        this.$q = $q;
        this.componentsDao = ComponentsDao;
        this.jfrogGridFactory = JFrogGridFactory;
        this.$stateParams = $stateParams;
        this.watchersDao = WatchersDao;
        this.user = User;
        this.binMgrDao = BinMgrDao;
        this.xrayLicensesDao = xrayLicensesDao;
        this.webhooksDao = WebhooksDao;
        this.modal = JFrogModal;
        this.JFrogUIUtils = JFrogUIUtils;
        this.XRayUIPermissions = XRayUIPermissions;
        this.TOOLTIP = TOOLTIPS.watchers;
        this.resourcesTableViewOptions = new JFrogTableViewOptions($scope);
        this.tableViewOptions = new JFrogTableViewOptions($scope);
        this.violationTotalCount = 0;
        this.severityType = ['All', 'Unknown', 'Information', 'Low', 'Medium', 'High'];
        this.violationTypes = ["All", "Security", "License"];
       this.setTimePicker();

        this.currentTab = 'violations';
        this.violationFilters = {
            type: "All",
            severity: "All",
            selectedTimeSpan: {text: 'All', value: 'all'}
        }
        this.defaultPagination = {direction: 'desc', num_of_rows: 5, order_by: 'last_updated', page_num: 1};
        this.modelSaver = XRayUIModelSaver.createInstance(this, ['watcherData', 'filters']);
        this._createPoliciesGrid();

        this.origFilterTypes = [
            {type: 'regex', displayName: 'Name', uiType: 'string', filterGroup: 'content'},
            {type: 'path-regex', displayName: 'Path', uiType: 'string', filterGroup: 'content'},
            {
                type: 'package-type',
                displayName: 'Package Type',
                uiType: 'dd',
                options: _.sortBy(
                    ['Maven', 'Docker', 'NuGet', 'Generic', 'Npm', 'Bower', 'Pypi', 'RPM', 'Debian', 'Gems']),
                filterGroup: 'content'
            },
            {type: 'mime-type', displayName: 'Mime Type', uiType: 'string', filterGroup: 'content'},
            /*
             {type: 'severity-level', displayName: 'Severity Level', uiType: 'string'},
             */
            {type: 'property', displayName: 'Property', uiType: 'keyVal', value: {}, filterGroup: 'content'}
            /*
             {type: 'aql', displayName: 'AQL', uiType: 'longText'}
             */
        ];


        this.filtersHelpFunction = (item) => {
            return this.TOOLTIP.helpPerFilterType[item.type];
        };
        this.issueFilters = [];
        this.contentFilters = [];
        this.filters = [];

        this.targetTypes = [];

        if (this.XRayUIPermissions.checkView('repos')) {
            this.targetTypes.push('Repository');
        }
        if (this.XRayUIPermissions.checkView('builds')) {
            this.targetTypes.push('Build');
        }

        if (this.XRayUIPermissions.hasGlobalManage('watches')) {

            this.targetTypes.push('All Builds', 'Every Artifact');
        }

        if (this.$stateParams.watcherName) {
            this.mode = 'edit';
            this.title = 'Watch';
            this.filterTypes = _.cloneDeep(this.origFilterTypes);
            this.issueFilterTypes = _.cloneDeep(this.newType);
            this.getWatcherData();
            this.tabs = [{name: 'violations', disabled: this.mode == 'new'}, {
                name: 'ignore_rules',
                disabled: this.mode == 'new'
            }, {name: 'settings'}];
            this.baseTabsDict = {violations: 'Violations', settings: 'Settings', ignore_rules: 'Ignore Rules'};

        }
        else {
            this.currentTab = 'settings';
            this.tabs = [{name: 'settings'}];
            this.baseTabsDict = {settings: 'Settings'};
            this.mode = 'new';
            this.manageable = true;
            this.title = 'Add New Watch';
            this.GlobalResources = {repository: false, build: false}
            this.hideGrid = true;

            this.watcherData = {
                project_resources: {resources: []},
                general_data: {active: true}
            };
            this.refreshFilterTypes();
        }

        this.tabsDict = _.cloneDeep(this.baseTabsDict);

        this.userIssuesGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getUserIssuesGridColumn())
            .setRowsPerPage(15)
            .setExternalPagination((pagination) => this.getViolations(pagination))
            .setButtons(this._getIssuesActions())
            .setGridData([]);

        this.createGrid();
    }

    setTimePicker(){

        this.violationTypesTimeSpanOptions = [
            {text: 'All', value: 'all'},
            {text: 'Last 3 Hours', value: '3h'},
            {text: 'Last 24 hours', value: '24h'},
            {text: 'Last 3 Days', value: '3d'},
            {text: 'Last 7 Days', value: '7d'},
            {text: 'Custom Range', value: 'CUSTOM'}
        ];

        this.datePicker = {startDate: null, endDate: null}
        this.dateRangeOpts = {
            locale: {
                applyClass: 'btn-green',
                applyLabel: "Apply",
                fromLabel: "From",
                format: "YYYY-MM-DD",
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            }
            /*ranges: {
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()]
            }*/
        };

        this.$scope.date = {}
        this.$scope.$watch('date', (newDate) => {
            if (newDate.startDate && newDate.endDate) {
                let start = new Date(newDate.startDate._d).getTime();
                let end = new Date(newDate.endDate._d).getTime();
                let final = start + "-" + end
                this.createdCustomTime = final;
            }
        }, false);
    }

    createGrid() {
        this.resourcesTableViewOptions.setId('resources-table')
            .setObjectName('Resource')
            .setColumns(this.getResourcesColumns())
            .setRowsPerPage(5)
            .setActions(this.getActions())

        if (this.mode === 'new') {
            this._setResourceEntityCreation();
        }

        this.resourcesTableViewOptions.on('row.clicked', (data) => {

            console.log("row clicked");
        });

        this.resourcesTableViewOptions.setData([])
        this.resourcesTableViewOptions.emptyTableText = 'Currently there are no assigned resources';
        this.resourcesTableViewOptions.newEntityCustomText = 'Manage Resources';
        this.resourcesTableViewOptions.sortBy('modified').reverseSortingDir();


    }

    getResourcesColumns() {
        return [
            {
                "header": "Name",
                "field": "name",
                'cellTemplate': `<div class="{{row.entity.priority}}">{{row.entity.name}}</div>`,
                "filterable": true
            },
            {
                "header": "Type",
                "field": "type",
                'cellTemplate': `<div disable-tooltip-on-overflow style="display:flex;flex-direction:row"> <div style="line-height: 28px;flex-shrink:1" jf-tooltip-on-overflow>{{grid.appScope.WatcherForm.getTranslatedTargetType(row.entity.type)}}</div></div>`,
                "allowGrouping": true,
                "filterable": true
            },
            {
                "header": "Instance",
                "field": "bin_mgr_id",
                "cellTemplate": `<div >{{row.entity.bin_mgr_id}}</div>`,
                /* "headerCellTemplate": `<div>{{col.header}} ({{appScope.ctrl.runningId}})</div>`,*/
                "allowGrouping": true
            }
        ]
    }


    getActions() {
        return [
            {
                icon: 'icon icon-sort-and-filter',
                tooltip: 'Manage Filters',
                callback: (row) => this.manageFilters(row),
                visibleWhen: (row) => (this.XRayUIPermissions.hasGlobalManage('watches') && row.type !== 'build' )|| (row.type !== 'build' && this.XRayUIPermissions.checkEdit('watchers') && row.permissions && row.permissions.manageable) || (this.mode === 'new' && row.type !== 'build')
            },
            {
                icon: 'icon icon-clear',
                tooltip: 'Unassign Resource',
                callback: (row) => this.unAssignResource(row),
                visibleWhen: (row) => this.XRayUIPermissions.hasGlobalManage('watches') || (this.XRayUIPermissions.checkEdit('watchers') && row.permissions && row.permissions.manageable) || this.mode === 'new'
            }
        ];
    }

    unAssignResource(row) {
        console.log("need to unassign specific resource: ", row);

        this.modal.confirm(`Are you sure you want unassign <strong>${row.name}</strong> from your resources list?`)
            .then(() => {

                if (row.type === 'all-repos') {
                    this.GlobalResources.repository = false;
                } else if (row.type === 'builds') {
                    this.GlobalResources.build = false;
                }

                this.watcherData.project_resources.resources.splice(_.findIndex(this.watcherData.project_resources.resources, {
                    type: row.type,
                    name: row.name,
                    bin_mgr_id: row.bin_mgr_id
                }), 1);

                this.isPolicyCompitable();
                this.resourcesTableViewOptions.update();

            });
    }

    unAssignPolicy(row) {

        this.modal.confirm(`Are you sure you want unassign <strong>${row.name}</strong> from your policies list?`)
            .then(() => {

                this.watcherData.policies.splice(_.findIndex(this.watcherData.policies, {
                    name: row.name,
                }), 1);

                if (!this.watcherData.policies.length) {
                    this.hideGrid = true;
                } else {
                    this.hideGrid = false;
                }

            });
    }

    getTranslatedTargetType(txt) {

        if (txt === 'all-repos') {
            return "All Repositories";
        }
        if (txt === 'builds') {
            return "All Builds";
        }
        return _.startCase(txt);
    }

    showPolicyRules(policy) {
        let modalScope = this.$scope.$new();
        modalScope.name = policy.name;
        modalScope.type = policy.type;
        modalScope.rules = policy.rules;
        modalScope.policy = policy;
        let options = {windowClass: 'rules-view-modal'};

        this.modal.launchModal('show_policy_rules_modal', modalScope, 'lg', true, options).result.then((response) => {


        });
    }

    setViolationCount(count) {
        this.baseTabsDict.violations = `Violations (${count})`;

        this.tabsDict = _.cloneDeep(this.baseTabsDict);

    }

    ignoreUserIssue(row, type) {
        this.IgnoreModal.launchForUserIssue(row).then((action) => {
            if (action.type === 'once') {
                this.ignoreWatchIssue(row, true, type, action.policies);
            }
            else if (action.type === 'permanently') {
                this.ignoreWatchIssue(row, false, type, action.policies);

            }
        });
    }

    clearFilters() {
        this.violationFilters = {
            type: "All",
            severity: "All",
            selectedTimeSpan: {text: 'All', value: 'all'}
        }
        this.cveQuery = "";
        this.searchBtnTriggered = false;
        //this.refreshGrid();
    }

    _getUserIssuesGridColumn() {
        return [
            {
                name: 'Summary',
                displayName: 'Summary',
                field: 'summary',
                cellTemplate: `<div ng-click="grid.appScope.WatcherForm.ShowViolationModal(row.entity)" class="ui-grid-cell-contents"><a class="jf-link">{{row.entity.summary}}</a></div>`,
                width: '20%'
            },
            {
                name: 'Severity',
                displayName: 'Severity',
                cellTemplate: '<div ng-class="[row.entity.severity.toLowerCase()]" class="severity ui-grid-cell-contents">{{row.entity.severity | capitalizeFirst}}</div>',
                field: 'severity',
                width: '10%'
            },
            {
                name: 'Type',
                displayName: 'Type',
                cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.type | capitalizeFirst}}</div>',
                field: 'type',
                width: '10%'
            },
            {
                name: 'Targets',
                displayName: 'Violated Resources',
                //cellTemplate: `<div  class="ui-grid-cell-contents"><a ui-sref="watchers.edit({watcherName:
                // row.entity.watcher_name})"> {{row.entity.watcher_name}} </a></div>`,
                field: 'watcher_name',
                cellTemplate: '<div class="jf-link ui-grid-cell-contents" ><a class="jf-link" ng-click="grid.appScope.WatcherForm.showResources(row.entity)" class="jf-link" >View Resources ({{row.entity.targets.length}})</a></div>',
                width: '15%'
            },
            {
                name: 'Component',
                displayName: 'Component',
                enableSorting: false,
                field: 'component',
                cellTemplate: `<div ui-sref="components.details({componentID: row.entity.source_id,componentVersion:row.entity.source_version})" class="ui-grid-cell-contents"><a class="jf-link">{{row.entity.source}}<span ng-if="row.entity.source_version">:{{row.entity.source_version}}</span></a></div>`,
                width: '15%'
            },
            {
                name: 'Impacted Artifact',
                displayName: 'Impacted Artifact',
                enableSorting: false,
                field: 'comp_name',
                cellTemplate: `<div ui-sref="components.details({componentID: grid.appScope.WatcherForm.getImpactName(row.entity) ,  componentVersion:row.entity.comp_version})" class="ui-grid-cell-contents"><a class="jf-link">{{row.entity.comp_name}}<span ng-if="row.entity.comp_version &&  row.entity.comp_version !== '' ">:{{row.entity.comp_version}}</span></a></div>`,
                width: '15%'
            },
            {
                name: 'updated',
                displayName: 'Created',
                field: 'updated',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.updated | date:'medium'}}</div>`,
                width: '15%'
            },
            {
                name: 'policies',
                field: 'policy',
                displayName: 'Policies',
                cellTemplate: this.commonGridColumns.listableColumn('row.entity.policies', 'row.entity.summary', null, false),
                width: '15%',
                customActions: [{
                    icon: 'icon icon-clear',
                    tooltip: 'Ignore Violation',
                    callback: (row) => {
                        this.ignoreUserIssue(row, row.type);
                    },
                    visibleWhen: (row) => row.permissions && row.permissions.manageable
                }]
            }

        ]
    }

    showResources(row) {
        console.log("need to show resources for", row);

        let modalScope = this.$scope.$new();

        this.tableViewOptions.setId('watch-targets-table')
            .setObjectName('Resource')
            .setColumns(this.getTargetsColumns())
            .setRowsPerPage(8)

        this.tableViewOptions.setData(row.targets);
        modalScope.modalTitle = `'${row.watcher_name}' Watch Resources `
        modalScope.tableOptions = this.tableViewOptions;

        this.modal.launchModal('show_list_grid_modal', modalScope).result.then(() => {

        }).catch(() => {

            console.log('closed Resources')
        });

    }

    getTargetsColumns() {

        return [
            {
                "header": "Type",
                "field": "type",
                'cellTemplate': `<div class="ui-grid-cell-contents" >{{row.entity.type | capitalizeFirst}}</div>`,
                "filterable": true
            },
            {
                "header": "Name",
                "field": "name",
                'cellTemplate': `<div class="ui-grid-cell-contents" >{{row.entity.name }}</div>`,
                "allowGrouping": true,
                "filterable": true
            },
            {
                "header": "Instance",
                'field': 'bin_mgr_id',
                'cellTemplate': `<div class="ui-grid-cell-contents" >{{row.entity.bin_mgr_id }}</div>`,
                "filterable": true
            }

        ]
    }

    getImpactName(row) {

        let ver = row.comp_version;
        let comp_id = row.comp_id;

        if (ver && ver !== '') {
            return comp_id.split(':' + ver)[0]
        } else {
            return comp_id;
        }
    }

    ShowViolationModal(row) {

        let issueModalData = this.$scope.$new();
        issueModalData.itemClicked = this.itemClicked;
        issueModalData.ctrl = this;
        issueModalData.wideMode = false;
        issueModalData.selectedIndex = this.selectedIndex;
        issueModalData.infected_comp = row.comp_id;
        issueModalData.paths = row.paths;
        issueModalData.matched_policies = row.matched_policies;
        let paramPayload = {};
        paramPayload.type = row.type;
        paramPayload.$no_spinner = true;
        let violatioRow = _.cloneDeep(row);
        if (row.type.toLowerCase() === 'license') {

        }

        delete violatioRow.watcher_id;
        delete violatioRow.paths;

        delete violatioRow.permissions;
        if (violatioRow.watcher_name) {
            violatioRow.watch_name = violatioRow.watcher_name;
            delete  violatioRow.watcher_name;
        }
        violatioRow.watch_target = violatioRow.target;

        delete violatioRow.target;
        delete violatioRow.watcher_name;
        violatioRow.type = this.$filter('capitalizeFirst')(violatioRow.type);
        if (violatioRow.fix_versions) {
            violatioRow.fixed_versions = violatioRow.fix_versions;
            delete  violatioRow.fix_versions;
        }
        if (violatioRow.source_id) {
            delete  violatioRow.source_id;
        }
        if (violatioRow.source) {
            violatioRow.infected_component = violatioRow.source;
            delete  violatioRow.source_id;
        }

        if (violatioRow.comp_id) {
            delete violatioRow.comp_id;
        }


        let package_type = '';
        if (violatioRow.source_id && violatioRow.source_id.indexOf('://') > -1) {
            violatioRow.package_type = this.xrayUtils.getPackageByPrefix(violatioRow.source_id.split('://')[0]);
            violatioRow.source_id = violatioRow.source_id.split('://')[1];

        }


        issueModalData.isViolation = true;
        issueModalData.details = violatioRow;
        if (violatioRow.type && violatioRow.type.toLowerCase() === 'security') {
            let issuePayload = {};
            issuePayload.vulnerability_id = row.issue_id;
            issuePayload.source_name = row.source;
            issuePayload.component_id = row.comp_id;
            this.componentsDao.getComponentIssues(paramPayload, issuePayload).$promise.then((alert) => {

                if (alert.cves) {
                    if (!alert.cves[0].cve) {
                        delete alert.cves;
                    } else {
                        issueModalData.details.cves = alert.cves;
                    }

                }
                if (alert.description) {
                    issueModalData.details.description = alert.description;
                }

                if (alert.package_type) {
                    issueModalData.details.package_type = this.$filter('capitalizeFirst')(alert.package_type);

                }

                if (alert.references) {
                    issueModalData.details.references = alert.references;
                }
                if (alert.provider) {
                    issueModalData.details.provider = alert.provider;
                }

                this.eventXDao.getImpactGraph(paramPayload, {
                    component_id: row.comp_id,
                    vulnerability_id: row.issue_id
                }).$promise.then((graph) => {
                    delete issueModalData.details.issue_id;
                    this.selectedIndex = 0;
                    issueModalData.graph = graph;
                    issueModalData.graph.component_id = this.xrayUtils.getComponentPrettyName(graph.component_id);
                    this.infectionGraph = graph.impact_paths;
                    if (graph.impact_paths.length == 0) {
                        issueModalData.wideMode = true;
                    }
                    issueModalData.details = this.orderDetailsObj(issueModalData.details);
                    this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/issue_modal.html'),
                            issueModalData).result.then(() => {

                    });
                });

            });
        } else {

            this.eventXDao.getImpactGraph(paramPayload, {
                component_id: row.comp_id,
                vulnerability_id: row.issue_id
            }).$promise.then((graph) => {
                delete issueModalData.details.issue_id;
                this.selectedIndex = 0;
                issueModalData.graph = graph;
                issueModalData.graph.component_id = this.xrayUtils.getComponentPrettyName(graph.component_id);
                this.infectionGraph = graph.impact_paths;
                if (graph.impact_paths.length == 0) {
                    issueModalData.wideMode = true;
                }
                issueModalData.details = this.orderDetailsObj(issueModalData.details);
                this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/issue_modal.html'),
                        issueModalData).result.then(() => {

                });
            });

            /*########*/
        }
    }

    orderDetailsObj(detailsObj) {


        let tmpObj = _.cloneDeep(detailsObj);
        let finaObj = {};

        finaObj = {
            summary: tmpObj.summary,
            description: tmpObj.description,
            type: tmpObj.type,
            provider: tmpObj.provider,
            severity: tmpObj.severity,
            update: tmpObj.updated,
            cves: tmpObj.cves,
            package_type: tmpObj.package_type,
            references: tmpObj.references,
            infected_component: tmpObj.infected_component,
            source_version: tmpObj.source_version,
            infected_versions: tmpObj.infected_versions,
            fixed_versions: tmpObj.fixed_versions,
            watch_target: tmpObj.watch_target,
            matched_policies: tmpObj.matched_policies
        }

        return _.omit(finaObj, _.isEmpty);
    }


    _getIssuesActions() {
        return [
            {
                icon: 'icon icon-artifactory-edit',
                tooltip: 'Edit Issue',
                callback: (row) => this.editIssue(row),
                visibleWhen: (row) => {
                    if (row.provider) {
                        return (this.XRayUIPermissions.isAdmin() || this.XRayUIPermissions.checkEdit(
                            'components')) && row.provider.toLowerCase() === 'custom';
                    }
                }

            },
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete Issue',
                callback: (row) => this.deleteIssue(row),
                visibleWhen: (row) => {
                    if (row.provider && this.XRayUIPermissions.checkEdit('components')) {
                        return (this.XRayUIPermissions.isAdmin() || this.XRayUIPermissions.checkEdit(
                            'components')) && row.provider.toLowerCase() === 'custom';
                    }
                }

            }

        ];
    }

    ignoreWatchIssue(row, once = true, type = 'security', policies) {
        let ignore_once = once;
        let payload = {};
        payload.comp_id = row.comp_id;
        payload.policies = policies;
        payload.watch_id = this.watcherData.general_data.id;
        payload.type = type;
        payload.issues = [row.issue_id];
        payload.target = row.target;
        payload.user_name = this.user.userName;

        this.componentsDao.ignoreOnceUserWatchIssues({ignore_once}, payload).$promise.then((data) => {

            if (this.userIssuesGridOptions && this.currentTab === 'violations') {
                this.userIssuesGridOptions.resetPagination();
            }
        });
    }

    getViolations(p) {

        let pagination = p || this.defaultPagination;
        let payload;

        this.violationFilters ? payload = this.buildFiltersPayload(this.violationFilters) : payload = {};
        payload.cve = payload.type === 'License' ? null : payload.cve;

        payload.watcherId = this.watcherData.general_data.id;

        pagination.num_of_rows = 15;
        let promise = '';
        payload = _.omit(payload, _.isEmpty);

        promise = this.watchersDao.getViolations(pagination, payload).$promise;

        promise.then((response) => {
            if (response.total_count == 0) {
                this.showViolationPH = true;
                this.resultsSummaryString = `  No Results found`;
            } else {
                this.showViolationPH = false;
                console.log('!!!! response is ', response);
                _.each(response.data, (val, key) => {

                    val.policies = _.map(val.matched_policies, 'policy')
                })
                if (response.data && response.data.length) {
                    if (response.total_count > this.violationTotalCount) {
                        this.violationTotalCount = response.total_count;
                    }
                    this.resultsSummaryString = `Showing ${response.total_count} out of ${this.violationTotalCount} Violations`;
                }
            }

            this.setViolationCount(response.total_count);

        });
        return promise;
    }

    buildFiltersPayload(filters) {
        let payload = _.cloneDeep(filters)


        _.forEach(payload, (val, key) => {
            if (key !== "selectedTimeSpan" && val.toLowerCase() === "all") {
                delete payload[key]
            } else if (key === "selectedTimeSpan") {
                if (val.value === "all") {
                    delete payload[key]
                } else {
                    if (val.value.toLowerCase() === "custom") {

                        if (this.createdCustomTime) {
                            payload.date = this.createdCustomTime;
                        } else {
                            delete payload.date;
                        }

                    } else {
                        payload.date = val.value;
                    }
                    delete payload[key]
                }
            }
        });

        payload.cve = this.cveConvertor();
        if (!payload.cve) {
            delete payload.cve;
        }
        return payload;
    }

    onChangeTimeSpan() {
        if (this.violationFilters.selectedTimeSpan.value === 'CUSTOM') {
            $('#daterange3').click()
        }
    }

    refreshGrid() {
        this.searchBtnTriggered = true;
        this.userIssuesGridOptions.resetPagination();
    }

    isArray(o) {
        return _.isArray(o);
    }

    isLink(str) {
        if (typeof str != 'string' || !str) {
            return false;
        }
        str = str.trim();
        return str && str.startsWith('http://') || str.startsWith('https://') || str.startsWith('www.');
    }

    itemClicked($index, ctrl) {

        ctrl.selectedIndex = $index;

    }

    seperateFilterGroups(filters) {


        filters.forEach((currentObj) => {
            this.contentFilters.push(currentObj);
        });

    }


    getWatcherData() {
        this.GlobalResources = {};
        this.watchersDao.getOne({}, {watcherName: this.$stateParams.watcherName}).$promise.then((data) => {
            if (data.permissions) {
                this.manageable = data.permissions.manageable;
            }
            if (this.manageable) {
                this._setResourceEntityCreation();
            }
            this.title = 'Watch "' + data.general_data.name + '"';
            this.filters = this._transformSavedFilters(data.filters);
            this.seperateFilterGroups(this.filters);
            this.watcherData = data;

            if (data.policies) {

                this.watcherData.policies = data.policies;

                this.policiesgridOptions.setGridData(this.watcherData.policies);
            } else {
                this.watcherData.policies = [];
            }


            if (this.watcherData.project_resources && this.watcherData.project_resources.resources.length > 0) {
                console.log("TRUE!!");
                this._arrangeResourcesForEdit()

            }
            this.resourcesTableViewOptions.setData(this.watcherData.project_resources.resources);

            delete this.watcherData.$promise;
            delete this.watcherData.$resolved;
            this._getIgnoreRules();
            this.isPolicyCompitable();
            this.refreshFilterTypes();

            this.modelSaver.save();

            if (!this.manageable) {
                this.title = 'Watch "' + data.general_data.name + '"';
            }

            this.canShowViolation = true;


        });
        this.ignoreGridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getIgnoreColumns())
            .setButtons(this._getIgnoreActions());


    }

    _setResourceEntityCreation() {

        this.resourcesTableViewOptions.emptyTableText = "No Resources"

        this.resourcesTableViewOptions.setNewEntityAction(() => {
            this.manageResources();
            this.resourcesTableViewOptions.update();
        });

        this.resourcesTableViewOptions.emptyTableCallActionText = 'Manage Resources';
        this.resourcesTableViewOptions.emptyTableAction = () => {
            this.manageResources();
        }
    }

    _arrangeResourcesForEdit() {
        _.each(this.watcherData.project_resources.resources, (val, key) => {

            if (val.name.endsWith('-cache')) {
                val.name = val.name.substr(0, val.name.lastIndexOf('-cache'));
            }

            if (val.filters && val.filters.length) {
                val.filters = this._transformSavedFilters(val.filters);
            }

            if (val.type === "all-repos" || val.type === "builds") {
                val.bin_mgr_id = "All Instances";
                val.draggable = false;
                val.custom_class = "global-resource"
                val.type === "builds" ? this.GlobalResources.build = true : this.GlobalResources.repository = true;
            }
            if (!val.permissions || (val.permissions && !val.permissions.manageable)) {
                val.draggable = false;
                val.custom_class = "disabled";
            }


        })
    }

    _arrangeForGrid(data) {
        if (!data) {
            return;
        }
        let mailObj = {
            type: 'Emails',
            data: data.emails,
            desc: 'Sends an email message to all configured recipients with details about the generated Violations'
        };
        let webhookObj = {
            type: 'Webhooks',
            data: data.webhooks,
            desc: 'Triggers the configured webhook(s) passing in the details of the generated Violations as a JSON payload'
        };
        let buildObj = {
            type: 'CI Integration',
            data: data.fail_build,
            desc: 'Xray\'s build integration allows you to manage your build jobs and configure them with appropriate actions if build artifacts or dependencies with watch Violations are found in your builds.'
        };

        let blockObj = {
            type: 'Block Download',
            data: data.block_download,
            desc: 'Use this action to prevent potentially harmful artifacts from being used by blocking them from being available for download from Artifactory'
        };


        let dataArr = [];

        if (mailObj.data && mailObj.data.length > 0) {
            dataArr.push(mailObj);
            this.hasMailsPost = true;

        } else {
            this.hasMailsPost = false;
        }

        if (webhookObj.data && webhookObj.data.length > 0) {
            dataArr.push(webhookObj);
            this.hasWebhooksPost = true;
        } else {
            this.hasWebhooksPost = false;
        }

        if (buildObj.data) {
            dataArr.push(buildObj);
            this.hasBuildsPost = true;
        } else {
            this.hasBuildsPost = false;
        }

        if (blockObj.data) {
            dataArr.push(blockObj);
            this.hasBlocksPost = true;
        } else {
            this.hasBlocksPost = false;
        }


        if (!dataArr.length) {
            this.hideGrid = true;
        } else {
            this.hideGrid = false;
        }

        return dataArr;


    }

    save() {
        let payload = _.cloneDeep(this.watcherData);
        //payload.filters = this._transformFiltersForSave(this.contentFilters, this.issueFilters);
        if (this.mode === 'edit') {
            payload.general_data.name;
        }

        let temp = {};
        for (let key in payload) {
            if (!key.startsWith('$')) {
                temp[key] = payload[key];
            }
        }

        payload = temp;

        let endPoint = this.mode === 'new' ? 'create' : 'update';
        _.each(payload.project_resources.resources, (val, key) => {

            if (val.type === "builds" || val.type === "all-repos") {
                delete val.bin_mgr_id;
            }
        });
        payload["policies"] = _.map(this.watcherData.policies, 'name')

        this.watchersDao[endPoint](payload).$promise.then((res) => {
            if (res.status === 200 || res.status === 201) {
                this.modelSaver.save();
                this.$state.go('watchers');
            }
        });
    }

    cancel() {
        this.$state.go('watchers');
    }


    _transformSavedpost_actions(post_actions) {
        if (!post_actions) {
            return;
        }
        let transformed = {};
        transformed.emails = post_actions.emails;
        transformed.fail_build = post_actions.fail_build;

        if (post_actions.block_download) {
            if (post_actions.block_download.active) {
                transformed.block_download = post_actions.block_download;
            }
        }

        transformed.webhooks = _.filter(post_actions.webhooks, wh => !!wh);


        return transformed;
    }

    addFilter(type) {
        this.selectedItemForFilters.filters = this.selectedItemForFilters.filters || [];

        if (!this.newFilterTypeIssue && !this.newFilterTypeContent) {
            return;
        }
        this.selectedItemForFilters.filters.push(_.cloneDeep(this.newFilterTypeContent));
        this.selectedItemForFilters.icon_class = "icon icon-sort-and-filter";
        delete this.newFilterTypeContent;

        this.refreshFilterTypes();
    }


    removeFilter(index, group, filter = {}) {
        //this.filters.splice(index,1);
        console.log("need to remove filter", filter);
        console.log("Index is", index);
        //let index = _.findIndex(this.selectedItemForFilters.filters, {type: filter.type, value: filter.value});
        console.log("Index is ", index);
        console.log("Selected item for filters is", this.selectedItemForFilters);
        this.selectedItemForFilters.filters.splice(index, 1);
        if (this.selectedItemForFilters.filters.length == 0) {
            delete this.selectedItemForFilters.icon_class;
        }
    }

    _transformFiltersForSave(contentFilterArr, issueFilterArr) {
        let transformed = [];
        contentFilterArr.forEach((filter) => {
            let constraint = _.pick(filter, ['type', 'value']);
            if (constraint.type === 'license-white' || constraint.type === 'license-black') {
                constraint.value = _.map(constraint.value, 'name');
            }
            if (constraint.type === 'package-type' && constraint.value === 'npm') {
                constraint.value = 'Npm';
            }
            if (constraint.type === 'package-type' && constraint.value === 'Gems') {
                constraint.value = 'rubygems';
            }
            transformed.push(constraint);
        });

        issueFilterArr.forEach((filter) => {
            let constraint = _.pick(filter, ['type', 'value']);
            if (constraint.type === 'license-white' || constraint.type === 'license-black') {
                constraint.value = _.map(constraint.value, 'name');
            }
            if (constraint.type === 'package-type' && constraint.value === 'npm') {
                constraint.value = 'Npm';
            }


            transformed.push(constraint);
        });

        return transformed;
    }

    _transformSavedFilters(filters) {
        let transformed = [];
        if (filters) {
            filters.forEach((origFilter) => {
                let filter = _.cloneDeep(_.find(this.filterTypes, {type: origFilter.type}));
                if (filter) {
                    filter.value = origFilter.value;

                    if (this.licenses && (filter.type === 'license-white' || filter.type === 'license-black')) {
                        filter.value = _.map(filter.value, (v) => _.find(this.licenses, {name: v}));
                    }

                    transformed.push(filter);
                }
            });
        }
        return transformed;
    }


    prettifyPackageType(value) {
        if (value === 'Pypi') {
            return 'PyPi';
        } else if (value === 'Npm') {
            return 'npm';
        } else {
            return value;
        }
    }

    isSaveDisabled() {
        if (!this.manageable) {
            return true;
        }
        if (!this.watcherData) {
            return false;
        }
        if (!this.watcherData.general_data.name || this.watcherData.general_data.name === '') {
            return true;
        }
        if (!this.watcherData.policies || (this.watcherData.policies && this.watcherData.policies.length == 0) || this.watcherData.project_resources.resources.length == 0) {
            return true;
        }

        return this.isAnyFilterEmpty();
    }

    isAnyFilterEmpty() {
        let emptyFilterFound = false;
        for (let i = 0; i < this.contentFilters.length; i++) {
            let filter = this.contentFilters[i];
            if (!filter.value || (filter.uiType === 'list' && !filter.value.length)) {
                emptyFilterFound = true;
                break;
            }
        }

        for (let i = 0; i < this.issueFilters.length; i++) {
            let filter = this.issueFilters[i];
            if (!filter.value || (filter.uiType === 'list' && !filter.value.length)) {
                emptyFilterFound = true;
                break;
            }
        }
        return emptyFilterFound;
    }

    checkName(value) {
        if (value) {
            if (value.indexOf('/') > -1) {
                return false;
            } else {
                return true;
            }
        }

    }

    refreshFilterTypes() {

        let target_type = ""; //this.watcherData.target_type.toLowerCase();

        this.filterTypes = _.filter(this.origFilterTypes, (filter) => this.isFilterSupported(filter, 'content'));
        this.isPolicyCompitable();
    }

    isFilterSupported(filter, filterGroup) {
        const FORBIDDEN_BUILD_FILTERS = ['package-type', 'mime-type', 'path-regex', 'property','regex'];
        const FORBIDDEN_ALL_BUILDS_FILTERS = ['package-type', 'mime-type', 'path-regex', 'property'];
        if (filterGroup === 'content') {
            console.log("Filter is ", filter);
            console.log("this.selectedItemForFilters is ", this.selectedItemForFilters);

            if (this.selectedItemForFilters && this.selectedItemForFilters.type === 'build' && _.includes(FORBIDDEN_BUILD_FILTERS, filter.type)) {
                return false;
            } else if (this.selectedItemForFilters && this.selectedItemForFilters.type === 'builds' && _.includes(FORBIDDEN_ALL_BUILDS_FILTERS, filter.type)) {
                return false;
            }
            else if (filter.type === 'package-type' && _.includes(_.map(this.contentFilters, 'type'),
                    'package-type')) {
                return 0; //Don't display warning message, but do filter out this filter type
            }
            else if (filter.type === 'mime-type' && _.includes(_.map(this.contentFilters, 'type'), 'mime-type')) {
                return 0; //Don't display warning message, but do filter out this filter type
            }
            else {
                return true;
            }

        }// filtering the content dd
    }

    selectListFilter(filter) {

        let modalScope = this.$scope.$new();
        let modalInstance;

        modalScope.modalTitle = 'Select ' + filter.displayName;
        modalScope.available = this.licenses;
        modalScope.selected = _.cloneDeep(filter.value);
        modalScope.fieldName = 'name';
        modalScope.saveList = (selected) => {
            filter.value = selected;
            modalInstance.close();
        };

        modalInstance = this.modal.launchModal('filter_select_list_modal', modalScope);

    }

    getListFilterDisplayValues(filter) {
        return _.map(filter.value, 'name').slice(0, 3).join(', ');
    }


    _createPoliciesGrid() {
        this.policiesgridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getColumns())

    }

    _getColumns() {
        return [

            {
                name: 'name',
                displayName: 'Name',
                field: 'name',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.name}}</div>`,
                width: '25%',
                customActions: [{
                    icon: 'icon-artifacts',
                    tooltip: 'Policy Summary',
                    callback: (row) => this.showPolicyRules(row),

                }]
            },
            {
                name: 'type',
                displayName: 'Type',
                field: 'type',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.type | capitalizeFirst}}</div>`,
                width: '25%'
            },
            {
                name: 'author',
                displayName: 'Author',
                field: 'author',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.author}}</div>`,
                width: '25%'
            },
            {
                name: 'modified',
                displayName: 'Modified',
                field: 'type',
                cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.modified | date:'medium'}}</div>`,
                width: '25%',
                customActions: [{
                    icon: 'icon-xray-policies',
                    tooltip: 'Navigate to policy',
                    callback: (row) => this.goToPolicy(row),

                },
                    {
                        icon: 'icon icon-clear',
                        tooltip: 'Unassign Policy',
                        callback: (row) => this.unAssignPolicy(row),
                        visibleWhen: (row) => this.XRayUIPermissions.checkEdit('watchers') || this.mode === 'new'
                    }]
            }
        ];
    }

    goToPolicy(row){
        console.log(row);
        this.$state.go('policies.edit', {policyName: row.name})
    }


    getIncompatibleText(rules) {
        let textArr = [];
        let plural = '';

        _.each(rules, (val, key) => {
            let tmpTxt = '';
            if (val.banned_targets.indexOf(',') > -1) {
                plural = 's';
            } else {
                plural = '';
            }
            tmpTxt = `Rule <strong>'${val.name}'</strong> contains a <strong>'${val.banned_targets}'</strong> action${plural} which is not compatible with  one of the resources target type (${val.problematicTargets})`;
            textArr.push(tmpTxt);
        });
        return textArr.join('\n');
    }

    getPoliciesActions(policy) {

        let actionsArr = _.map(policy.rules, "actions");
        let finalActionsArr = [];
        _.each(actionsArr, (val, key) => {
            finalActionsArr.push(_.keys(val))
        })

        let finalArr = _.uniq(_.flatten(finalActionsArr));
// Cleaning Hash
        if (finalArr.indexOf('$$hashKey') > -1) {
            let index = finalArr.indexOf("$$hashKey")
            finalArr.splice(index, 1);
        }
        console.log('Final Actions Array IS :: ', finalArr);
        return finalArr;
    }

    _getActions() {

        return [

            {
                icon: 'icon-artifacts',
                tooltip: 'Policy Summary',
                callback: (row) => this.showPolicyRules(row),

            }
        ];
    }


    onChangeTab(tab) {
        let oldTab = this.currentTab;
        this.currentTab = tab.name;
        if (oldTab !== this.currentTab) {

        }

        if (this.currentTab == 'settings') {
            if (this.mode !== 'new') {
                this.$state.params.title = "Watch Settings";
                this.resourcesTableViewOptions.update();
                this.policiesgridOptions.refreshColumns();
            }
            this.$timeout(() => {
                $(document).trigger('resize');
            }, 500);
        } else if (this.currentTab == 'violations') {
            this.$timeout(() => {
                this.$state.params.title = "Watch Violations";
            })
        }
        else {
            this.$timeout(() => {
                this.$state.params.title = 'Ignore Rules';
                this.$timeout(() => {
                    $(document).trigger('resize');
                }, 500);
            });
        }
    }

    getNomalizedKey(key) {

        if (key.toLowerCase() == 'cves') {
            return 'CVEs';
        }
        return _.startCase(key);
    }

    cveConvertor() {
        if (!this.cveQuery) {
            return null;
        }
        let hasCve = this.cveQuery.toLowerCase().indexOf('cve-') > -1;
        let original = _.cloneDeep(this.cveQuery).toUpperCase().replace('CVE-', '');
        let final = '';


        switch (true) {
            case /^\d{4}-\d$/.test(original.toUpperCase()):
                final = 'CVE-' + original + '.*';
                break;

            case /^\d{4}-\d{0,3}$/.test(original.toUpperCase()):
                final = 'CVE-' + original + '.*';
                break;
            case /^\d/.test(original.toUpperCase()):
                if (!hasCve) {
                    final = '.*' + original + '.*';
                } else {
                    final = 'CVE-' + original + '.*';
                }
                break;
            default:
                final = undefined;
                break;

        }
        if (final) {
            final = final.replace('--', '-');
            final = final.replace('-CVE', '');
            final = final.replace('.*CVE', 'CVE');
        }

        //console.log('final query', final);
        return final;
    }

    checkCveValidity(val) {
        if (!val) {
            return true;
        }

        let nomalizedVal = val.toLowerCase().replace('cve-', '')


        if (val == 'true' || val == "") {
            return true
        }
        return /^\d{4}-\d$/.test(nomalizedVal.toUpperCase()) || /^\d{4}-\d{0,3}$/.test(
            nomalizedVal.toUpperCase()) || /^\d/.test(nomalizedVal.toUpperCase());
    }


    /* Policy Management segment */

    addPolicy() {
        console.log('Need to promopt add policy modal')
        let modalScope = this.modalScope = this.$scope.$new();


        this.PolicyDao.getAll().$promise.then((policies) => {
            let includedPolicies = _.cloneDeep(this.watcherData.policies) || [];
            let excludePolicies = _.filter(policies, (p) => {

                return _.findIndex(includedPolicies, {name: p.name}) < 0

            });
            modalScope.ctrl = this;
            modalScope.columns =
                modalScope.excludeList = excludePolicies;
            modalScope.includeList = includedPolicies;
            modalScope.columns = [
                {
                    header: "Name",
                    field: "name",
                    width: "50%",

                },
                {
                    header: "Type",
                    field: "type",
                    width: "50%",
                }
            ]


            this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/assign_policy.html'), modalScope).result.then(() => {
                console.log('Assign Policy ', modalScope.includeList)

                this.watcherData.policies = modalScope.includeList;
                console.log("*** ASIIGNING GRID DATA", this.watcherData.policies);
                this.policiesgridOptions.setGridData(this.watcherData.policies);
                this.isPolicyCompitable();
                modalScope.includeList.length > 0 ? this.hideGrid = false : this.hideGrid = true;
            }).catch(() => {

                console.log('Assign Policy Aborted')
            });

        });

    }

    onChangeDnd(row) {
        console.log("DND CHANGED!");
    }


    /* Resources Management segment */

    manageResources(mode = "resources", row = {}) {
        console.log('Need to promopt add resources modal')
        this.modalScope = this.$scope.$new();
        this.modalScope.ctrl = this;
        this.modalScope.mode = mode;
        console.log(mode);
        if (!this.allResources) {
            console.log("No cached resources");
            this.getAllResources().then(() => {
                this.setResourcesFilters(row);
                this.showResourceModal(this.modalScope)
            });
        } else {
            this.setResourcesFilters(row);
            this.showResourceModal(this.modalScope)
        }
    }

    setResourcesFilters(row) {
        let selectedResources = this.watcherData.project_resources ? _.cloneDeep(this.watcherData.project_resources.resources) : [];
        _.each(selectedResources, (val, key) => {
            if(val.type !== 'build'){
                val.clickable = true;
            }
        });
        let availableResources = _.filter(this.allResources, (r) => {
            return _.findIndex(selectedResources, {bin_mgr_id: r.bin_mgr_id, name: r.name}) < 0
        });
        this.modalScope.excludeList = availableResources;
        this.modalScope.includeList = selectedResources;

        if (this.modalScope.mode === 'filters') {
            this.selectedItemForFilters = _.find(this.modalScope.includeList, {
                bin_mgr_id: row.bin_mgr_id,
                name: row.name
            });
            this.selectedItemForFilters.highlighted = true;
            this.refreshFilterTypes();
        } else if (this.selectedItemForFilters) {

            this.selectedItemForFilters = _.find(this.modalScope.includeList, {
                bin_mgr_id: this.selectedItemForFilters.bin_mgr_id,
                name: this.selectedItemForFilters.name
            });
            this.selectedItemForFilters.highlighted = true;
        }

    }

    manageFilters(row) {
        console.log("need to manage filtes for", row);


        this.manageResources('filters', row);

    }

    getAllResources() {

        let defer = this.$q.defer();
        this.fetchingResources = true;
        this.watchersDao.getAllResources({$no_spinner: true}).$promise.then((resources) => {

            this.allResources = resources;
            console.log("GetAllResource() Function", this.allResources);

            _.forEach(this.allResources, (val, key) => {
                console.log("val is", val);
                console.log(this.GlobalResources);
                val.clickable = true;
                if (val.type == 'build' && this.GlobalResources.build) {
                    val.draggable = false;
                    val.custom_class = "disabled";
                } else if (val.type == 'repository' && this.GlobalResources.repository) {
                    val.draggable = false;
                    val.custom_class = "disabled";
                }

            });
            this.fetchingResources = false;
            defer.resolve(true);
        });


        return defer.promise;
    }

    resourceForFilterSelected(item) {
        console.log(item);

        this.selectedItemForFilters = item;
        this.refreshFilterTypes();
    }

    setGlobalResource(type, excludeList, includeList) {
        let allReposObj = {
            name: "All Repositories",
            type: "all-repos",
            clickable: true,
            draggable: false,
            meta_type: "global_repo",
            bin_mgr_id: "All Instances",
            custom_class: "global-resource"
        }
        let allBuildsObj = {
            name: "All Builds",
            type: "builds",
            clickable: true,
            draggable: false,
            meta_type: "global_build",
            bin_mgr_id: "All Instances",
            custom_class: "global-resource"
        }

        let itemsToExclude = _.remove(includeList, (i) => {
            return i.type == type
        });

        excludeList.splice(excludeList.length, 0, ...itemsToExclude);
        console.log(this.GlobalResources[type]);

        _.each(excludeList, (val, key) => {
            if (val.type == type && this.GlobalResources[type]) {
                val.draggable = false;
                val.custom_class = "disabled";
            } else if (val.type == type && !this.GlobalResources[type]) {
                val.draggable = true;
                val.custom_class = "enabled";
            }
        });

        if (this.GlobalResources[type]) {
            if (type == "build") {
                includeList.push(allBuildsObj);
            } else if (type == "repository") {
                includeList.push(allReposObj);
            }

        } else {
            if (type == "build") {
                includeList.splice(_.findIndex(includeList, {type: "builds"}), 1);
            } else if (type == "repository") {
                includeList.splice(_.findIndex(includeList, {type: "all-repos"}), 1);
            }
        }
    }

    onChangeDnd(excludeList) {
        console.log("Finished Drag", excludeList);
    }

    showResourceModal(modalScope) {

        modalScope.columns = [
            {
                header: "Name",
                field: "name",
                width: "33%",

            },
            {
                header: "Type",
                field: "type",
                cellTemplate: `<div disable-tooltip-on-overflow style="display:flex;flex-direction:row"> <div style="line-height: 28px;flex-shrink:1" jf-tooltip-on-overflow>{{row.entity.type | capitalizeFirst}}</div></div>`,
                width: "34%",
            },
            {
                header: "Instance",
                field: "bin_mgr_id",
                width: "33%",

            }
        ]
        console.log("ModalScope is ", modalScope.includeList);
        _.each(modalScope.includeList, (val, key) => {
            console.log("Val is", val);
            if (val.filters && val.filters.length) {
                val.icon_class = 'icon icon-sort-and-filter'
                val.icon_tooltip = 'Filtered Resource'
            }
        });
        if (_.findIndex(modalScope.includeList, {name: 'All Repositories'}) > -1) {
            this.GlobalResources.repository = true;
        }
        if (_.findIndex(modalScope.includeList, {name: 'All Builds'}) > -1) {
            this.GlobalResources.build = true;
        }
        this.modal.launchModalWithTemplateMarkup(require('../../modal_templates/manage_resources.html'), modalScope).result.then(() => {
            console.log('Manage Resources ', modalScope.includeList)

            _.forEach(modalScope.includeList, (val, key) => {

                delete val.highlighted;

            });
            this.watcherData.project_resources.resources = modalScope.includeList;

            this.resourcesTableViewOptions.setData(this.watcherData.project_resources.resources);
            this.isPolicyCompitable();
        }).catch(() => {

            console.log('Manage Resources Aborted')
        });
    }


    isPolicyCompitable() {

        let allTargetTypes = _.map(this.watcherData.project_resources.resources, 'type')
        _.each(this.watcherData.policies, (policy, key) => {

            policy.incompitableRules = [];
            policy.isCompitable = true;
            console.log('Policy is ', policy.name);

            _.each(policy.rules, (rule) => {
                let tmpRuleObj = {};
                tmpRuleObj.problematicTargets = [];
                if (!rule.banned_targets) {
                    return;
                }
                _.each(allTargetTypes, (targetType) => {
                    if (!_.find(rule.banned_targets, {type: targetType})) {
                        return;
                    }

                    tmpRuleObj.name = rule.name;
                    tmpRuleObj.banned_targets = _.find(rule.banned_targets, {type: targetType}).incompatible_actions
                        .join(', ');
                    if (targetType == 'all-repos') {
                        targetType = "All Repositories"
                    }
                    if (targetType == 'builds') {
                        targetType = "All Builds"
                    }
                    tmpRuleObj.problematicTargets.push(_.startCase(targetType));
                    policy.isCompitable = false;
                });
                tmpRuleObj.problematicTargets = _.uniq(tmpRuleObj.problematicTargets);
                policy.incompitableRules.push(tmpRuleObj);
            });

        });

    }


    /*===== Set Ignore Grid ====== */

    _getIgnoreColumns() {
        return [
            {
                name: 'Issues',
                displayName: 'Violations',
                field: 'issuesCount',
                cellTemplate: '<div ng-if="row.entity.issues.length > 1" class="ui-grid-cell-contents">{{row.entity.issues.length}} <strong jf-tooltip="{{row.entity.issuesSummary}}">(See List)</strong></div>' +
                '<div ng-if="row.entity.issues.length === 1" class="ui-grid-cell-contents">{{row.entity.issuesSummary}}</div>',
                width: '20%'
            },
            {
                name: 'policies',
                field: 'policy',
                displayName: 'Policies',
                cellTemplate: this.commonGridColumns.listableColumn('row.entity.policies',
                    'row.entity.issues[0].summary', null, false),
                width: '20%'
            },
            {
                name: 'Creation Time',
                displayName: 'Creation Time',
                cellTemplate: `<div class="ui-grid-cell-contents creation-time-col"  >{{row.entity.created | date:'medium' }}</div>`,
                field: 'created',
                width: '20%'
            },
            {
                name: 'Author',
                displayName: 'Author',
                cellTemplate: `<div class="ui-grid-cell-contents"  >{{row.entity.user_name }}</div>`,
                field: 'user_name',
                width: '20%'
            },
            {
                name: 'notes',
                displayName: 'Notes',
                cellTemplate: `<div class="ui-grid-cell-contents"  >{{row.entity.notes ? row.entity.notes : 'N/A'  }}</div>`,
                field: 'notes',
                width: '20%'
            }
        ];
    }


    _getIgnoreRules() {
        this.ignoreDao.get({watch_id: this.watcherData.id}).$promise.then((ignoreRules) => {
            ignoreRules.forEach((rule) => {
                rule.issuesSummary = _.map(rule.issues, 'summary').join('<br/>');
                rule.watch_target = this._getWatchTarget(rule);
            });
            this.ignoreGridOptions.setGridData(_.filter(ignoreRules,(i)=>{

               return  i.watch_name == this.$stateParams.watcherName
            }));
        });
    }

    _getWatchTarget(rule) {
        let targetType = '';
        if (rule.watch_target_type === 'artifact') {
            targetType = 'Every Artifact';
        } else if (rule.watch_target_type === 'builds') {
            targetType = 'All Builds';
        } else {
            targetType = rule.watch_art_id + '::' + rule.watch_target_type + '::' + rule.watch_target_name;
        }

        return targetType;

    }

    _getIgnoreActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => this.deleteIgnoreRule(row),
                visibleWhen: (row) => row.permissions.manageable
            }

        ];
    }

    deleteIgnoreRule(rule) {
        this.modal.confirm('Are you sure you want to delete this ignore rule ?')
            .then(() => {
                this.ignoreDao.deleteIgnore({}, {id: rule.id}).$promise.then((res) => {
                    this._getIgnoreRules();
                    //this.setTabCounter();
                });
            });
    }

    checkValidFilters(includeList) {


        let invalidFilterResources = _.filter(includeList, (i) => {
            let hasInvalidFilter = false;
            _.forEach(i.filters, (val) => {

                if (val.type === "property") {

                    if (!val.value.key || !val.value.value || (val.value.value && val.value.value == "") || (val.value.key && val.value.key == "")) {
                        hasInvalidFilter = true;
                    }
                }
                else if (!val.value) {
                    hasInvalidFilter = true;
                }
            });
            return hasInvalidFilter
        });

        return invalidFilterResources.length;
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/watchers/watcher_form.controller.js